var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OmitType, PartialType, PickType } from "@nestjs/swagger";
import { IsBoolean, IsEnum, IsOptional } from "class-validator";
import { BaseOrganizationDto, BaseOrganizationPublicProfileDto } from "./organization.dtos";
import { UserType } from "./user.dtos";
export class ExternalResearcherOrganizationPublicProfileDto extends BaseOrganizationPublicProfileDto {
    constructor(fields) {
        super();
        this.type = UserType.EXTERNAL_RESEARCHER;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(UserType),
    __metadata("design:type", Object)
], ExternalResearcherOrganizationPublicProfileDto.prototype, "type", void 0);
export class ExternalResearcherOrganizationDto extends BaseOrganizationDto {
    constructor(fields) {
        super();
        this.type = UserType.EXTERNAL_RESEARCHER;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(UserType),
    __metadata("design:type", Object)
], ExternalResearcherOrganizationDto.prototype, "type", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], ExternalResearcherOrganizationDto.prototype, "require21CFRPart11ForInformedConsents", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], ExternalResearcherOrganizationDto.prototype, "defaultRequire21CFRPart11ForInformedConsents", void 0);
export class CreateExternalResearcherOrganizationInput extends PickType(ExternalResearcherOrganizationDto, ["name"]) {
    constructor() {
        super(...arguments);
        this.type = UserType.EXTERNAL_RESEARCHER;
    }
}
__decorate([
    IsEnum(UserType),
    __metadata("design:type", Object)
], CreateExternalResearcherOrganizationInput.prototype, "type", void 0);
export class UpdateExternalResearcherOrganizationInput extends PartialType(PickType(ExternalResearcherOrganizationDto, ["name"])) {
    constructor() {
        super(...arguments);
        this.type = UserType.EXTERNAL_RESEARCHER;
    }
}
__decorate([
    IsEnum(UserType),
    __metadata("design:type", Object)
], UpdateExternalResearcherOrganizationInput.prototype, "type", void 0);
export class UpdateExternalResearcherOrganizationDetailsInput extends PartialType(OmitType(ExternalResearcherOrganizationDto, ["id", "name", "onChainAddress", "adminEmail"])) {
    constructor(fields) {
        super();
        this.type = UserType.EXTERNAL_RESEARCHER;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(UserType),
    __metadata("design:type", Object)
], UpdateExternalResearcherOrganizationDetailsInput.prototype, "type", void 0);
